import { CommonChartModel, PieChartModel, CHART_TYPE, ColumnChartModel, AxisType } from "./chart.model";
import { DataTableSchema, DefaultTableSchema, TITLE_TYPE } from "./dynamic-data-table.model";
import { FieldNames, TotalCountText, VenuesDropdown } from "./form-fields.model";

export const Labels = {
  lexusCentral: 'Lexus Central',
  lexusEastern: 'Lexus Eastern',
  lexusSouthern: 'Lexus Southern',
  lexusWestern: 'Lexus Western',
  hq: 'HQ',
  dealerCode: 'Dealer Code',
  dealerName: 'Dealer Name',
  grandTotal: 'Grand Total',
  area: 'Area',
  district: 'District',
  RegistrationCountByArea :'Registration Count by Area',
  EnrollmentHistoryTracking:'Enrollment History Tracking'
} as const;



export const EventAreaRegisteredChart: CommonChartModel = {
    ...structuredClone(ColumnChartModel),
    tooltip: {
        headerFormat: '<span style="font-size:11px"><b>{point.dataset.venue}</b></span><br>',
        pointFormat: `
        <span>${Labels.lexusCentral}</span>: <b><span>{point.dataset.lexusCentral}</span></b><br/>
        <span>${Labels.lexusEastern}</span>: <b><span>{point.dataset.lexusEastern}</span></b><br/>
        <span>${Labels.lexusSouthern}</span>: <b><span>{point.dataset.lexusSouthern}</span></b><br/>
        <span>${Labels.lexusWestern}</span>: <b><span>{point.dataset.lexusWestern}</span></b><br/>
        <span>${Labels.hq}</span>: <b><span>{point.dataset.hq}</span></b><br/>
        `
    },
    legend: {
        enabled: true,
    },
    dataSchema: {
        label: 'venue',
        value: ['lexusCentral', 'lexusEastern','lexusSouthern','lexusWestern','hq'],
        tooltipLabelInfo: {
            'lexusCentral': Labels.lexusCentral,
            'lexusEastern': Labels.lexusEastern,
            'lexusSouthern': Labels.lexusSouthern,
            'lexusWestern': Labels.lexusWestern,
            'hq': Labels.hq
        }
        
    },
    titleSchema: {
        label: '',
        subLabel: "",
        title: 'Registration Count by Venue',
        type: TITLE_TYPE['Static']
    },
    xAxis: {
        title: {
            text: 'Venue',
        }
    },
    yAxis: {
        title: {
            text: 'Count',
        }
    },
    plotOptions: {
    column: {
        pointWidth: 26,
        maxPointWidth: 50,
        pointPadding:0.1,   
        groupPadding: 0.1,
        borderWidth: 0
    }
    },
    series: [{
        name: Labels.lexusCentral,
        type: CHART_TYPE['ColumnChart'],
        data: [],
        key: 'lexusCentral',
        color: '#B61D22',
    },
    {
        name: Labels.lexusEastern,
        type: CHART_TYPE['ColumnChart'],
        data: [],
        key: 'lexusEastern',
        color: '#C2A676'
    },
{
        name: Labels.lexusSouthern,
        type: CHART_TYPE['ColumnChart'],
        data: [],
        key: 'lexusSouthern',
        color: '#3A4A37'
    },
    {
        name: Labels.lexusWestern,
        type: CHART_TYPE['ColumnChart'],
        data: [],
        key: 'lexusWestern',
        color: '#B07566'
    },
{
        name: Labels.hq,
        type: CHART_TYPE['ColumnChart'],
        data: [],
        key: 'hq',
        color: '#0057CC'
    }]
}

const RegisteredVenueChart: CommonChartModel = {
    ...structuredClone(ColumnChartModel),
    isLineChart: true,
    tooltip: {
        shared: false,
        useHTML: true,
        formatter: function(this: any) {
            const seriesName = this.series ? this.series.name : '';
            const point = this.point;
            const dataset = point?.dataset ? point.dataset : {};            
            if (seriesName === 'Registered' || seriesName === 'Withdrawn') {
                return `
                    <span style="font-size:11px"><b>${seriesName}</b></span><br/>
                    <span>Registration Date</span>: <b>${dataset.weekrange || '-'}</b><br/>
                    <span>${seriesName}</span>: <b>${point.y}</b><br/>
                `;
            }
            return '';
        }
    },
    dataSchema: {
        label: 'weekrange',
        value: ['registeredcount', 'withdrawncount'],
        tooltipLabelInfo: {
            'registeredcount': 'Registered',
            'withdrawncount': 'Withdrawn'
        }
    },
    titleSchema: {
        title: 'Trend by Date',
        type: TITLE_TYPE['Static']
    },
    xAxis: {
        type: AxisType['Category'],
        title: {
            text: 'Registration Date',
        }
    },
    yAxis: {
        title: {
            text: 'Count',
        },
        max: null 
    },
    plotOptions: {
        line: {
            marker: {
                enabled: true
            }
        },
        series: {
            stacking: undefined,
            dataLabels: {
                enabled: false
            }
        }
    },
    series: [{
        name: 'Registered',
        color: '#7ab1e7',
        data: [],
        key: 'registeredcount',
        dataLabels: {
            enabled: false
        },
    },
    {
        name: 'Withdrawn',
        color: '#e77b7b',
        data: [],
        key: 'withdrawncount',
        dataLabels: {
            enabled: false
        },
    }],
}
export const RegisteredVenueChartSchema = {
    chartSchema : RegisteredVenueChart,
    chartType: CHART_TYPE['ColumnChart'],
    exportConfig: {
        fileName: 'Trend_by_Date',
        exportMessage:"Trend by Date Data",        
        schema: {
            weekrange: "Registration Date",
            registeredcount: "Registered",
            withdrawncount: "Withdrawn"
        }
    },
    filterSchema: {
        formName: 'trendByDateVenueFilter',
        FieldsArray: structuredClone([{
            ...VenuesDropdown, payloadInfo: {
                [FieldNames['Venue']]: ''
            },
            isLoading:true
        }])
    },
    infoFields: structuredClone([{
        ...TotalCountText, calculateBy: ['registeredcount', 'withdrawncount']
    }]),
}

export const EventAreaTableReport: DataTableSchema = {
    ...structuredClone(DefaultTableSchema),
    tableTitle: "Registration Count by Venue",
    columnSchema: [
        { label: 'AREA', fieldKey: 'venue', isNotCamelCase: true },
        { label: Labels.lexusCentral, fieldKey: 'lexusCentral' },
        { label: Labels.lexusEastern, fieldKey: 'lexusEastern' },
        { label: Labels.lexusSouthern, fieldKey: 'lexusSouthern' },
        { label: Labels.lexusWestern, fieldKey: 'lexusWestern' },
        { label: Labels.hq, fieldKey: 'hq' },
        { label: Labels.grandTotal, fieldKey: 'grandTotal' }
    ],
    isFooterRequired: true,
    columnSigns: {
        labelColumnText: 'amount',
    },
    footerConfig: {
        labelColumnText: Labels.grandTotal,
        fields:['lexusCentral','lexusEastern','lexusSouthern','lexusWestern','hq','grandTotal']
    },
    isExportRequired: true,
    exportConfig: {
        fileName: 'Registration_Count_by_Venue',
        schema: {
            venue: "AREA",
            lexusCentral: Labels.lexusCentral,
            lexusEastern: Labels.lexusEastern,
            lexusSouthern: Labels.lexusSouthern,
            lexusWestern: Labels.lexusWestern,
            hq: Labels.hq,
            grandTotal: Labels.grandTotal,

        },
        footer:{
            sum:[{fieldKey:'title',label:Labels.grandTotal},{fieldKey:'lexusCentral',sumBy:'lexusCentral'},{fieldKey:'lexusEastern',sumBy:'lexusEastern'},{fieldKey:'lexusEastern',sumBy:'lexusEastern'},
                {fieldKey:'lexusSouthern',sumBy:'lexusSouthern'},{fieldKey:'lexusWestern',sumBy:'lexusWestern'},{fieldKey:'hq',sumBy:'hq'},{fieldKey:'grandTotal',sumBy:'grandTotal'}
            ]
        },
        exportMessage: "Registration Count by Venue Data"
    },
    isSearchRequired: true,
    isPaginationRequired: true,
    tableRowHeight:true
}

export const EventDealerTableReport: DataTableSchema = {
    ...structuredClone(DefaultTableSchema),
    tableTitle: "Registration Count by Dealer",
    columnSchema: [
        { label: Labels.dealerCode, fieldKey: 'dealerCode' },
        { label: Labels.dealerName, fieldKey: 'dealerName' },
        { label: Labels.area, fieldKey: 'area' },
        { label: Labels.district, fieldKey: 'district' },
        { label: '# of Registrations', fieldKey: 'numberOfRegistration' }
    ],
    isFooterRequired: false,
    isTableGap: true,
    isExportRequired: true,
    exportConfig: {
        fileName: 'Registration_Count_by_Dealer',
        schema: {
            dealerCode: "DEALER CODE",
            dealerName: "DEALER NAME",
            area: "AREA",
            district: "DISTRICT",
            numberOfRegistration: "# OF REGISTRATIONS",
        },
        exportMessage: "Registration Count by Dealer Data"
    },
    isSearchRequired: true,
    isPaginationRequired: true,
    isshowsubtable:true,
    tableRowHeight:true
}

const EventAreaPieChartDrilldown: CommonChartModel = {
    ...structuredClone(PieChartModel),
    tooltip: {
        headerFormat: `<span style="font-size:11px">{point.name}</span><br>`,
        pointFormat: `<span>Count</span>: <b> {point.y}</b><br/>`
    },
    dataSchema: {
        label: 'areaName',
        value: 'totalCount',
        drillDownConfig: {
            xAxis: {
                title: 'Dealers'
            },
            drillDownField: "dealerDetails",
            label: "dealer",
            value: "count",
            type: CHART_TYPE['BarChart'],
            tooltip: {
                headerFormat: `<span style="font-size:11px">{point.name}</span><br>`,
                pointFormat: `
                <span>Dealer Name</span>: <b>{point.dataset.dealerName}</b><br/>
                <span>Area</span>: <b>{point.dataset.area}</b><br/>
                <span>District</span>: <b>{point.dataset.district}</b><br/>
                <span>Count</span>: <b>{point.dataset.count}</b><br/>
                `
            },
            titleSchema: {
                label: '',
                subLabel: "",
                title: Labels.RegistrationCountByArea,
                type: TITLE_TYPE['Static']
            },
        }
    },
    titleSchema: {
        label: '',
        subLabel: "",
        title: Labels.RegistrationCountByArea,
        type: TITLE_TYPE['Static']
    },
    xAxis: {
        title: {
            text: 'Dealers',
        }
    },
    yAxis: {
        title: {
            text: 'Count',
        }
    },
    dataLabels: {
        enabled: true,
        format: "{point.name}: " + "{point.y}"
    }

}

export const EventAreaPieChartSchema = {
    chartSchema : EventAreaPieChartDrilldown,
    chartType: CHART_TYPE['PieChart'],
    exportConfig: {
        fileName: 'Registration_Count_by_Area',
        exportMessage: "Registration Count by Area",
        isCamelCase:['dealer','dealerName','area'],
        schema: {
            dealer: Labels.dealerCode,
            dealerName: Labels.dealerName,
            area: Labels.area,
            district: Labels.district,
            count: "Count"
        }
    },
    filterSchema: {},
    infoFields: structuredClone([{
        ...TotalCountText,fieldName:'count', calculateBy: 'totalCount'
    }]),
}

const EventAreaWithdrawnPieChartDrilldown: CommonChartModel = {
    ...structuredClone(PieChartModel),
    tooltip: {
        headerFormat: `<span style="font-size:11px">{point.name}</span><br>`,
        pointFormat: `<span>Count</span>: <b> {point.y}</b><br/>`
    },
    dataSchema: {
        label: 'areaName',
        value: 'totalCount',
        drillDownConfig: {
            xAxis: {
                title: 'Dealers'
            },
            drillDownField: "dealerDetails",
            label: "dealer",
            value: "count",
            type: CHART_TYPE['BarChart'],
            tooltip: {
                headerFormat: `<span style="font-size:11px">{point.name}</span><br>`,
                pointFormat: `
                <span>Dealer Name</span>: <b>{point.dataset.dealerName}</b><br/>
                <span>Area</span>: <b>{point.dataset.area}</b><br/>
                <span>District</span>: <b>{point.dataset.district}</b><br/>
                <span>Count</span>: <b>{point.dataset.count}</b><br/>
                `
            },
            titleSchema: {
                label: '',
                subLabel: "",
                title: 'Withdrawn Count by Area',
                type: TITLE_TYPE['Static']
            },
        }
    },
    titleSchema: {
        label: '',
        subLabel: "",
        title: 'Withdrawn Count By Area',
        type: TITLE_TYPE['Static']
    },
    xAxis: {
        title: {
            text: 'Dealers',
        }
    },
    yAxis: {
        title: {
            text: 'Count',
        }
    },
    dataLabels: {
        enabled: true,
        format: "{point.name}: " + "{point.y}"
    }

}

export const EventAreaWithdrawnPieChartSchema = {
    chartSchema : EventAreaWithdrawnPieChartDrilldown,
    chartType: CHART_TYPE['PieChart'],
    exportConfig: {
        fileName: 'Withdrawn_Count_by_Area',
        exportMessage: "Withdrawn Count by Area",
        isCamelCase:['dealer','dealerName','area'],
        schema: {
            dealer: Labels.dealerCode,
            dealerName: Labels.dealerName,
            area: "Area",
            district: "District",
            count: "Count"
        }
    },
    filterSchema: {},
    infoFields: structuredClone([{
        ...TotalCountText,fieldName:'count', calculateBy: 'totalCount'
    }]),
}

export const EventDuplicateRegReport: DataTableSchema = {
    ...structuredClone(DefaultTableSchema),
    tableTitle: "Duplicate Registrations List",
    columnSchema: [
        { label: 'SPIN ID', fieldKey: 'spinId', sticky: true },
        { label: Labels.dealerCode, fieldKey: 'dealerCode', sticky: true },
        { label: 'First Name', fieldKey: 'firstName' },
        { label: 'Last Name', fieldKey: 'lastName' },
        { label: 'Area', fieldKey: 'area' },
        { label: 'Duplicate Count', fieldKey: 'duplicateCount' },
    ],
    isFooterRequired: false,
    isTableGap: false,
    isExportRequired: true,
    isFilterListExportRequired: false,
    exportConfig: {
        fileName: 'Duplicate_Registrations_List',
        schema: {
            spinId:"SPIN ID",
            dealerCode: "DEALER CODE",
            firstName: "FIRST NAME",
            lastName: "LAST NAME",
            area: "AREA",
            registrationDate:"REGISTRATION DATE",
            registrationStatus: "REGISTRATION STATUS",
            duplicateCount: "DUPLICATE COUNT"
        },
        exportMessage: "Duplicate Registrations List"
    },
    tableRowHeight:true,
    isSearchRequired: false,
    isPaginationRequired: true
}

export const EventZeroRegReport: DataTableSchema = {
    ...structuredClone(DefaultTableSchema),
    title: "Zero Registration Dealer List",
    columnSchema: [
        { label: Labels.dealerCode, fieldKey: 'dealerCode' },
        { label: 'Area', fieldKey: 'area' },
        { label: 'District', fieldKey: 'district' },
    ],
    isFooterRequired: false,
    isTableGap: true,
    isExportRequired: false,
    isSearchRequired: false,
    isPaginationRequired: true,
    tableRowHeight:true
}

export const EventRegInputHistorySchema: DataTableSchema = {
    ...structuredClone(DefaultTableSchema),
    tableTitle: Labels.EnrollmentHistoryTracking,
    columnSchema: [
        { label: 'SPIN ID', fieldKey: 'spinId', sticky: true },
        { label: Labels.dealerCode, fieldKey: 'dealerCode', sticky: true },
        { label: Labels.area, fieldKey: 'area' },
        { label: Labels.district, fieldKey: 'district' },
        { label: 'Date', fieldKey: 'date' },
        { label: 'Status', fieldKey: 'registrationstatus' },
        { label: 'Location/Venue', fieldKey: 'venue' }
    ],
    isFooterRequired: false,
    isTableGap: false,
    isExportRequired: true,
    exportConfig: {
        fileName: 'Enrollment_History_Tracking',
        schema: {
            spinId: "Spin ID",
            dealerCode: "Dealer Code",
            area: "Area",
            district: "District",
            date: "Date",
            registrationstatus: "Status",
            venue: "Location/Venue",
        },
        exportMessage: Labels.EnrollmentHistoryTracking
    },
    isSearchRequired: true,
    isPaginationRequired: true,
    tableRowHeight: true
}
